module.exports = __webpack_public_path__ + "static/na-bce621d7a0ba967981e81fb212192310.jpg";